import { render, staticRenderFns } from "./file.upload.component.vue?vue&type=template&id=736d108f&scoped=true&"
import script from "./file.upload.component.vue?vue&type=script&lang=ts&"
export * from "./file.upload.component.vue?vue&type=script&lang=ts&"
import style0 from "./file.upload.component.vue?vue&type=style&index=0&id=736d108f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d108f",
  null
  
)

export default component.exports